import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withKeys as _withKeys, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "translation__wrapper" }
const _hoisted_2 = { class: "translation" }
const _hoisted_3 = { class: "translation__left" }
const _hoisted_4 = { class: "translation__radio" }
const _hoisted_5 = { class: "translation__lang" }
const _hoisted_6 = { class: "translation__container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "translation__checkmark" }, null, -1)
const _hoisted_8 = { class: "translation__lang" }
const _hoisted_9 = { class: "translation__container" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "translation__checkmark" }, null, -1)
const _hoisted_11 = { class: "translation__inputs" }
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.Ti18N("dictionary.getTranslate")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _createTextVNode("RU "),
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "ru",
                name: "lang",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radioLang) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.radioLang]
              ]),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, [
              _createTextVNode("EN "),
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "en",
                name: "lang",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.radioLang) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.radioLang]
              ]),
              _hoisted_10
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.findTanslate && _ctx.findTanslate(...args)), ["enter"])),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.wordTranslation) = $event)),
            class: "input-light",
            type: "text"
          }, null, 544), [
            [_vModelText, _ctx.wordTranslation]
          ]),
          _createElementVNode("button", {
            class: "profile__run",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.findTanslate && _ctx.findTanslate(...args)))
          }, _toDisplayString(_ctx.Ti18N("dictionary.search")), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "translation__result",
        style: _normalizeStyle(_ctx.result?.ruWord != '' && _ctx.result?.enWord != '' ? '' : 'visibility: hidden')
      }, [
        (_ctx.result?.ruWord != '' && _ctx.result?.enWord != '')
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.result.enWord) + " - " + _toDisplayString(_ctx.result.ruWord), 1))
          : _createCommentVNode("", true),
        (!_ctx.isPagesNull)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              ref: "btn",
              class: "profile__run modal-button__run",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addToDictionary && _ctx.addToDictionary(...args)))
            }, _toDisplayString(_ctx.Ti18N("dictionary.addToDictionary")), 513))
          : _createCommentVNode("", true)
      ], 4)
    ])
  ]))
}